import { adminHttpClient } from '../commons/adminHttpClient'

export type DeleteCustomCategoryRequest = {
  customCategoryId: number
  productClassId: string
}

const deleteCustomCategory = async (values: DeleteCustomCategoryRequest): Promise<number> => {
  return await adminHttpClient.delete('/Expenses/DeleteCustomCategory', { data: values })
}

export default deleteCustomCategory
